var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { FieldBizType } from '../_constants/field';
var baseValidateField = function (curEntity, originField, nowField) {
    if (!nowField) {
        return "\u5B9E\u4F53\u3010".concat(curEntity.name, "\u3011\u4E2D\u5B57\u6BB5\u5B58\u5728\u53D8\u66F4\uFF0C\u539F\u3010").concat(originField.name, "\u3011\u5B57\u6BB5\u5DF2\u88AB\u5220\u9664");
    }
    if (originField.name !== nowField.name) {
        return "\u5B9E\u4F53\u3010".concat(curEntity.name, "\u3011\u4E2D\u5B57\u6BB5\u540D\u5B58\u5728\u53D8\u66F4\uFF0C\u7531\u3010").concat(originField.name, "\u3011\u53D8\u66F4\u4E3A\u3010").concat(nowField.name, "\u3011");
    }
    if (originField.bizType !== nowField.bizType || (originField.bizType === nowField.bizType && originField.dbType !== nowField.dbType)) {
        return "\u5B9E\u4F53\u3010".concat(curEntity.name, "\u3011\u4E2D\u5B57\u6BB5\u3010").concat(originField.name, "\u3011\u7C7B\u578B\u5B58\u5728\u53D8\u66F4\uFF0C\u7531\u3010").concat(originField.typeLabel, "\u3011\u53D8\u66F4\u4E3A\u3010").concat(nowField.typeLabel, "\u3011");
    }
};
var getFieldIdsByConditions = function (conditions, fieldIds) {
    conditions.forEach(function (con) {
        if (con.conditions) {
            getFieldIdsByConditions(con.conditions, fieldIds);
        }
        else {
            con.fieldId && fieldIds.push(con.fieldId);
        }
    });
};
/** 校验删除组件数据是否需要用户变更 */
export var validateEntityForDelete = function (entities, newEntity, conditions) {
    if (entities === void 0) { entities = []; }
    if (conditions === void 0) { conditions = []; }
    var curEntity = entities.find(function (e) { return e.selected; });
    if (newEntity && curEntity && curEntity.id === newEntity.id) {
        var fieldIds_1 = [];
        getFieldIdsByConditions([conditions], fieldIds_1);
        if (newEntity._destroyed) {
            return "\u5B9E\u4F53\u3010".concat(newEntity.name, "\u3011\u5DF2\u5220\u9664");
        }
        if (curEntity.name !== newEntity.name) {
            return "\u5B9E\u4F53\u540D\u5B58\u5728\u53D8\u66F4\uFF0C\u7531\u3010".concat(curEntity.name, "\u3011\u53D8\u66F4\u4E3A\u3010").concat(newEntity.name, "\u3011");
        }
        var willAffectedFields = curEntity.fieldAry.filter(function (f) { return fieldIds_1.includes(f.id); });
        var _loop_1 = function (idx) {
            var originField = willAffectedFields[idx];
            var nowField = newEntity.fieldAry.find(function (f) { return f.id === originField.id; });
            var error = baseValidateField(curEntity, originField, nowField);
            if (error) {
                return { value: error };
            }
        };
        for (var idx = 0; idx < willAffectedFields.length; idx++) {
            var state_1 = _loop_1(idx);
            if (typeof state_1 === "object")
                return state_1.value;
        }
    }
};
/** 校验实体是否存在变更 */
export var validateEntity = function (entities, newEntity, options) {
    var _a, _b;
    var curEntity = entities.find(function (e) { return e.selected; });
    if (curEntity && newEntity && curEntity.id === newEntity.id) {
        if (newEntity._destroyed) {
            return "\u5B9E\u4F53\u3010".concat(newEntity.name, "\u3011\u5DF2\u5220\u9664");
        }
        var willAffectedFields = curEntity.fieldAry;
        /** 更新数据组件只判断所使用到的字段 */
        if (options) {
            var _c = options.conAry, conAry = _c === void 0 ? [] : _c, _d = options.conditions, conditions = _d === void 0 ? [] : _d;
            var fieldIds_2 = [];
            var fieldNames_1 = conAry.map(function (con) { return con.to.slice(1); });
            getFieldIdsByConditions([conditions], fieldIds_2);
            willAffectedFields = curEntity.fieldAry.filter(function (f) { return fieldIds_2.includes(f.id) || fieldNames_1.includes(f.name); });
        }
        if (curEntity.name !== newEntity.name) {
            return "\u5B9E\u4F53\u540D\u5B58\u5728\u53D8\u66F4\uFF0C\u7531\u3010".concat(curEntity.name, "\u3011\u53D8\u66F4\u4E3A\u3010").concat(newEntity.name, "\u3011");
        }
        var _loop_2 = function (idx) {
            var originField = willAffectedFields[idx];
            var nowField = newEntity.fieldAry.find(function (f) { return f.id === originField.id; });
            var error = baseValidateField(curEntity, originField, nowField);
            if (error || !nowField) {
                return { value: error };
            }
            if (originField.defaultValueWhenCreate !== nowField.defaultValueWhenCreate) {
                return { value: "\u5B9E\u4F53\u3010".concat(curEntity.name, "\u3011\u4E2D\u5B57\u6BB5\u3010").concat(originField.name, "\u3011\u9ED8\u8BA4\u503C\u5B58\u5728\u53D8\u66F4") };
            }
            if (originField.useEncrypt !== nowField.useEncrypt) {
                return { value: "\u5B9E\u4F53\u3010".concat(curEntity.name, "\u3011\u4E2D\u5B57\u6BB5\u3010").concat(originField.name, "\u3011\u52A0\u5BC6\u65B9\u5F0F\u5B58\u5728\u53D8\u66F4") };
            }
            if (originField.notNull !== nowField.notNull) {
                return { value: "\u5B9E\u4F53\u3010".concat(curEntity.name, "\u3011\u4E2D\u5B57\u6BB5\u3010").concat(originField.name, "\u3011\u975E\u7A7A\u5224\u65AD\u65B9\u5F0F\u5B58\u5728\u53D8\u66F4") };
            }
            if (originField.bizType === FieldBizType.ENUM
                && ((_a = originField.enumValues) === null || _a === void 0 ? void 0 : _a.join(',')) !== ((_b = nowField.enumValues) === null || _b === void 0 ? void 0 : _b.join(','))) {
                return { value: "\u5B9E\u4F53\u3010".concat(curEntity.name, "\u3011\u4E2D\u5B57\u6BB5\u3010").concat(originField.name, "\u3011\u679A\u4E3E\u9009\u9879\u5B58\u5728\u53D8\u66F4") };
            }
        };
        for (var idx = 0; idx < willAffectedFields.length; idx++) {
            var state_2 = _loop_2(idx);
            if (typeof state_2 === "object")
                return state_2.value;
        }
    }
};
/** 校验实体是否存在变更 */
export var depValidateEntity = function (params) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
    var entities = params.entities, newEntity = params.newEntity, _s = params.fields, fields = _s === void 0 ? [] : _s, conditions = params.conditions, _t = params.orders, orders = _t === void 0 ? [] : _t;
    var curEntity = entities.find(function (e) { return e.selected; });
    if (!curEntity || !newEntity) {
        return;
    }
    var originEntity = entities.find(function (e) { return e.id === newEntity.id; });
    if (originEntity) {
        var entityMap_1 = {};
        var whereFields_1 = [];
        var getFieldIdsByConditions_1 = function (conditions) {
            conditions.forEach(function (con) {
                if (con.conditions) {
                    getFieldIdsByConditions_1(con.conditions);
                }
                else {
                    con.fieldId && whereFields_1.push(con);
                }
            });
        };
        getFieldIdsByConditions_1([conditions]);
        __spreadArray(__spreadArray(__spreadArray([], whereFields_1, true), fields, true), orders, true).forEach(function (f) {
            if (!entityMap_1[f.entityId]) {
                entityMap_1[f.entityId] = [f];
            }
            else {
                entityMap_1[f.entityId].push(f);
            }
        });
        var usedFieldIds_1 = ((_a = entityMap_1[newEntity.id]) === null || _a === void 0 ? void 0 : _a.map(function (f) { return f.fieldId; })) || [];
        if (usedFieldIds_1.length) {
            if (newEntity._destroyed) {
                return "\u5B9E\u4F53\u3010".concat(newEntity.name, "\u3011\u5DF2\u5220\u9664");
            }
            var willAffectedFields = originEntity.fieldAry.filter(function (f) { return usedFieldIds_1.includes(f.id); });
            if (originEntity.name !== newEntity.name) {
                return "\u5B9E\u4F53\u540D\u5B58\u5728\u53D8\u66F4\uFF0C\u7531\u3010".concat(originEntity.name, "\u3011\u53D8\u66F4\u4E3A\u3010").concat(newEntity.name, "\u3011");
            }
            var _loop_3 = function (idx) {
                var originField = willAffectedFields[idx];
                var nowField = newEntity.fieldAry.find(function (f) { return f.id === originField.id; });
                var error = baseValidateField(originEntity, originField, nowField);
                if (error || !nowField) {
                    return { value: error };
                }
                if (originField.bizType === FieldBizType.RELATION && originField.relationEntityId !== nowField.relationEntityId) {
                    return { value: "\u5B9E\u4F53\u3010".concat(originEntity.name, "\u3011\u4E2D\u5B57\u6BB5\u3010").concat(originField.name, "\u3011\u6240\u5173\u8054\u7684\u5B9E\u4F53\u5B58\u5728\u53D8\u66F4") };
                }
                if (originField.showFormat !== nowField.showFormat) {
                    return { value: "\u5B9E\u4F53\u3010".concat(originEntity.name, "\u3011\u4E2D\u5B57\u6BB5\u3010").concat(originField.name, "\u3011\u6570\u636E\u683C\u5F0F\u5316\u65B9\u5F0F\u5B58\u5728\u53D8\u66F4") };
                }
                if (originField.mapping && !nowField.mapping) {
                    return { value: "\u5B9E\u4F53\u3010".concat(originEntity.name, "\u3011\u4E2D\u5B57\u6BB5\u3010").concat(originField.name, "\u3011\u6240\u6620\u5C04\u6570\u636E\u5B58\u5728\u53D8\u66F4") };
                }
                if (originField.mapping && nowField.mapping) {
                    if (originField.mapping.condition !== nowField.mapping.condition
                        || originField.mapping.fieldJoiner !== nowField.mapping.fieldJoiner
                        || originField.mapping.type !== nowField.mapping.type
                        || ((_b = originField.mapping.entity) === null || _b === void 0 ? void 0 : _b.id) !== ((_c = nowField.mapping.entity) === null || _c === void 0 ? void 0 : _c.id)
                        || ((_d = originField.mapping.entity) === null || _d === void 0 ? void 0 : _d.name) !== ((_e = nowField.mapping.entity) === null || _e === void 0 ? void 0 : _e.name)
                        || ((_f = originField.mapping.entity) === null || _f === void 0 ? void 0 : _f.fieldAry.length) !== ((_g = nowField.mapping.entity) === null || _g === void 0 ? void 0 : _g.fieldAry.length)) {
                        return { value: "\u5B9E\u4F53\u3010".concat(originEntity.name, "\u3011\u4E2D\u5B57\u6BB5\u3010").concat(originField.name, "\u3011\u6240\u6620\u5C04\u6570\u636E\u5B58\u5728\u53D8\u66F4") };
                    }
                    var originMappingFieldIds = (_h = originField.mapping.entity) === null || _h === void 0 ? void 0 : _h.fieldAry.map(function (f) { return f.id; }).sort().join(',');
                    var newMappingFieldIds = (_j = nowField.mapping.entity) === null || _j === void 0 ? void 0 : _j.fieldAry.map(function (f) { return f.id; }).sort().join(',');
                    var originMappingFieldNames = (_k = originField.mapping.entity) === null || _k === void 0 ? void 0 : _k.fieldAry.map(function (f) { return f.name; }).sort().join(',');
                    var newMappingFieldNames = (_l = nowField.mapping.entity) === null || _l === void 0 ? void 0 : _l.fieldAry.map(function (f) { return f.name; }).sort().join(',');
                    if (originMappingFieldIds !== newMappingFieldIds || originMappingFieldNames !== newMappingFieldNames) {
                        return { value: "\u5B9E\u4F53\u3010".concat(originEntity.name, "\u3011\u4E2D\u5B57\u6BB5\u3010").concat(originField.name, "\u3011\u6240\u6620\u5C04\u6570\u636E\u5B58\u5728\u53D8\u66F4") };
                    }
                    var _loop_4 = function (calcField) {
                        var originCalcField = (_r = (_q = originField.mapping.entity) === null || _q === void 0 ? void 0 : _q.fieldAry) === null || _r === void 0 ? void 0 : _r.find(function (f) { return f.id === calcField.id; });
                        if ((originCalcField === null || originCalcField === void 0 ? void 0 : originCalcField.sql) !== (calcField === null || calcField === void 0 ? void 0 : calcField.sql)) {
                            return { value: "\u5B9E\u4F53\u3010".concat(originEntity.name, "\u3011\u4E2D\u5B57\u6BB5\u3010").concat(originField.name, "\u3011\u6240\u6620\u5C04\u6570\u636E\u5B58\u5728\u53D8\u66F4") };
                        }
                    };
                    for (var _i = 0, _u = (_p = (_o = (_m = nowField.mapping.entity) === null || _m === void 0 ? void 0 : _m.fieldAry) === null || _o === void 0 ? void 0 : _o.filter(function (f) { return f.bizType === FieldBizType.CALC; })) !== null && _p !== void 0 ? _p : []; _i < _u.length; _i++) {
                        var calcField = _u[_i];
                        var state_4 = _loop_4(calcField);
                        if (typeof state_4 === "object")
                            return state_4;
                    }
                }
            };
            for (var idx = 0; idx < willAffectedFields.length; idx++) {
                var state_3 = _loop_3(idx);
                if (typeof state_3 === "object")
                    return state_3.value;
            }
        }
    }
};
